module.exports = "/cyber/_next/static/images/iphone-bc4cb949994133dd3992a2622bf8176f.png";